export default __webpack_public_path__ + "static/media/dunkin.eb480a76.png";